export const tr = {
    access: 'erişim yetkileri',
    id: 'id',
    'product-name': 'ürün adı'
};
